/**
   * @prop --stzh-pi-teaser-image-background-color: Background color if no image is present
 */

:host {
  --image-background-color: var(--stzh-pi-teaser-image-background-color, #{$colorPrimary30});

  display: flex;
  flex-direction: column;
}

.stzh-pi-teaser {
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: var(--stzh-color-white);

  &__wrapper {
    display: flex;
    flex-grow: 1;
    @include spaceCurve('padding-right', 'intermediary');
    @include spaceCurve('padding-left', 'intermediary');
    @include spaceCurve('padding-top', 'intermediary');
    @include spaceCurve('padding-bottom', 'regular');
    flex-direction: column;
    align-items: flex-start;
  }

  &__image {
    width: 100%;
    display: none;
  }

  &__dateline {
    @include font('title');
    @include fontCurve('p1');
    color: var(--stzh-color-coolgrey70);
    margin: 0 0 var(--stzh-space-small);
  }

  &__title {
    @include font('title');
    @include fontCurve('teaser');
    @include wordWrap;

    color: var(--stzh-color-black);
    margin: 0;

    display: -webkit-box;
    -webkit-line-clamp: 3; /* Limit the text to 3 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis; /* Adds "..." at the end if truncated */
    //line-height: 1.0 !important;
  }

  &__title-link {
    display: block;
    font-family: inherit;
    padding: 0;
    appearance: none;
    background-color: transparent;
    border: none;
    color: var(--stzh-color-black);
    text-decoration-line: none;
    transition: color $baseTransitionAnimationSpeed;
    border-radius: $buttonBorderRadius;
    cursor: pointer;

    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &::after {
      z-index: 1;
    }
  }

  &__lead {
    @include fontSize('milli');
    margin-top: 0;
    @include spaceCurve('margin-bottom', 'small');
  }

  &__date {
    color: var(--stzh-color-coolgrey70);
    margin: 0;
    text-align: right;
    width: 100%;
  }

  /* Has image */
  &--has-image &__image {
    display: block;
  }

  &--has-image &__lead {
    @include spaceCurve('margin-top', 'tiny');
  }

  /* Title ratio styling (no image) */
  &__title-ratio {
    --background-color: var(--image-background-color);
  }

  &__title-ratio &__title-wrapper {
    display: flex;
    flex-direction: column;
    @include spaceCurve('padding-top', 'intermediary');
    @include spaceCurve('padding-right', 'intermediary');
    @include spaceCurve('padding-bottom', 'intermediary');
    @include spaceCurve('padding-left', 'intermediary');
  }

  &__title-ratio &__dateline {
    margin-bottom: var(--stzh-space-xxsmall);
  }
}

